/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CreateCommentDontAgreeInput = {
    readonly commentID: string;
    readonly commentRevisionID: string;
    readonly additionalDetails?: string | null;
    readonly clientMutationId: string;
};
export type CreateCommentDontAgreeMutationVariables = {
    readonly input: CreateCommentDontAgreeInput;
};
export type CreateCommentDontAgreeMutationResponse = {
    readonly createCommentDontAgree: {
        readonly comment: {
            readonly id: string;
            readonly viewerActionPresence: {
                readonly dontAgree: boolean;
            } | null;
        } | null;
        readonly clientMutationId: string;
    } | null;
};
export type CreateCommentDontAgreeMutation = {
    readonly response: CreateCommentDontAgreeMutationResponse;
    readonly variables: CreateCommentDontAgreeMutationVariables;
};



/*
mutation CreateCommentDontAgreeMutation(
  $input: CreateCommentDontAgreeInput!
) {
  createCommentDontAgree(input: $input) {
    comment {
      id
      viewerActionPresence {
        dontAgree
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CreateCommentDontAgreeInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "createCommentDontAgree",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "CreateCommentDontAgreePayload",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "comment",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Comment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "viewerActionPresence",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ActionPresence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "dontAgree",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clientMutationId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CreateCommentDontAgreeMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "CreateCommentDontAgreeMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "CreateCommentDontAgreeMutation",
            "id": "04c072131f7a514932b44dfb44f6640d",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '13eea54efa80c2ea58e7b45760b4d71d';
export default node;
